import React, { useState } from "react";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import moment from "moment";

function LineDetails({ lineData }) {
  const [value, setValue] = useState(0);
  return (
    <div className="row">
      <div className="col-12 _orderFullDetailsLineTabDiv">
        <TabContext value={value}>
          <TabList
            variant="scrollable"
            scrollButtons="auto"
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          >
            {lineData.map((value, index) => {
              return <Tab label={`Line Details ${index + 1}`} />;
            })}
          </TabList>
          <SwipeableViews
            index={value}
            onChangeIndex={(index) => setValue(index)}
          >
            {lineData.map((ele, index) => {
              return (
                <TabPanel
                  value={value}
                  index={index}
                  key={index}
                  className="_orderFullDetailsLineDataTabDiv _orderListFullDetailsComponentTableDiv "
                >
                  <table>
                    <tbody>
                      <tr>
                        <th>Item No.</th>
                        <th>:</th>
                        <td>{ele?.LinePartNumber ?? ""}</td>
                        <th>Description</th>
                        <th>:</th>
                        <td>{ele?.LineDescription ?? ""}</td>
                      </tr>
                      <tr>
                        <th>Inner Packs</th>
                        <th>:</th>
                        <td>{ele?.LineInnerPacks ?? ""}</td>
                        <th>Inner Package Type</th>
                        <th>:</th>
                        <td>{ele?.LineInnerPacksUnit ?? ""}</td>
                      </tr>
                      <tr>
                        <th>Outer Packs</th>
                        <th>:</th>
                        <td>{ele?.LineOuterPacks ?? ""}</td>
                        <th>Outer Package Type</th>
                        <th>:</th>
                        <td>{ele?.LineOuterPacksUnit ?? ""}</td>
                      </tr>
                      <tr>
                        <th>Outer Pack Length </th>
                        <th>:</th>
                        <td>
                          {ele?.LineOuterPacksLength ?? ""}{" "}
                          {ele?.UnitOfDimension
                            ? ele?.UnitOfDimension?.toLowerCase()
                            : ""}
                        </td>
                        <th>Outer Pack Width</th>
                        <th>:</th>
                        <td>
                          {ele?.LineOuterPacksWidth ?? ""}{" "}
                          {ele?.UnitOfDimension
                            ? ele?.UnitOfDimension?.toLowerCase()
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Outer Pack Height</th>
                        <th>:</th>
                        <td>
                          {ele?.LineOuterPacksHeight ?? ""}{" "}
                          {ele?.UnitOfDimension
                            ? ele?.UnitOfDimension?.toLowerCase()
                            : ""}
                        </td>
                        <th>Qty. Ordered</th>
                        <th>:</th>
                        <td>
                          {ele?.LineQuantity ?? ""}{" "}
                          {ele?.UnitOfQuantity
                            ? ele?.UnitOfQuantity?.toLowerCase()
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Qty. Received</th>
                        <th>:</th>
                        <td>
                          {ele?.LineRecievedQuantity ?? ""}{" "}
                          {ele?.UnitOfQuantity
                            ? ele?.UnitOfQuantity?.toLowerCase()
                            : ""}
                        </td>
                        <th>Qty. Remaining</th>
                        <th>:</th>
                        <td>
                          {ele?.LineRemainingQuantity ?? ""}{" "}
                          {ele?.UnitOfQuantity
                            ? ele?.UnitOfQuantity?.toLowerCase()
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Actual Volume</th>
                        <th>:</th>
                        <td>
                          {ele?.LineActualVolume ?? ""}{" "}
                          {ele?.LineUnitOfVolume
                            ? ele?.LineUnitOfVolume?.toLowerCase()
                            : ""}
                        </td>
                        <th>Actual Weight</th>
                        <th>:</th>
                        <td>
                          {ele?.LineActualWeight ?? ""}{" "}
                          {ele?.LineUnitOfWeight
                            ? ele?.LineUnitOfWeight?.toLowerCase()
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th>Item Price</th>
                        <th>:</th>
                        <td>{ele?.LineItemPrice ?? ""}</td>
                        <th>Total Price</th>
                        <th>:</th>
                        <td>{ele?.LineTotalPrice ?? ""}</td>
                      </tr>
                      <tr>
                        <th>Required in-store</th>
                        <th>:</th>
                        <td>
                          {ele?.LineReqInStoreDate === "1900-01-01 00:00:00.000"
                            ? ""
                            : ele?.LineReqInStoreDate
                              ? moment(ele?.LineReqInStoreDate).format(
                                "MM-DD-YYYY"
                              )
                              : ""}
                        </td>
                        <th>INCO term</th>
                        <th>:</th>
                        <td>{ele?.LineIncoTerms ?? ""}</td>
                      </tr>
                      <tr>
                        <th>Aditional Terms</th>
                        <th>:</th>
                        <td>{ele?.LineAdditionalTerms ?? ""}</td>
                        <th>Confirm Number</th>
                        <th>:</th>
                        <td>{ele?.LineConfirmNumber ?? ""}</td>
                      </tr>
                      <tr>
                        <th>Confirm Date</th>
                        <th>:</th>
                        <td>
                          {ele?.LineConfirmDate === "1900-01-01 00:00:00.000"
                            ? ""
                            : ele?.LineConfirmDate
                              ? moment(ele?.LineConfirmDate).format("MM-DD-YYYY")
                              : ""}
                        </td>
                        <th>Container Number</th>
                        <th>:</th>
                        <td>{ele?.LineContainerNumber ?? ""}</td>
                      </tr>
                    </tbody>
                  </table>
                </TabPanel>
              );
            })}
          </SwipeableViews>
        </TabContext>
      </div>
    </div>
  );
}

export default LineDetails;
